import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listar(paginacao) {
  return axios.get('financeiro/contas-financeiras', { params: paginacao }).then((response) => response.data);
}

function abrir(id) {
  return axios.get(`financeiro/contas-financeiras/${id}`).then((response) => response.data);
}

function salvar(conta) {
  return axios.post('financeiro/contas-financeiras', conta).then((response) => response.data);
}

function atualizar(conta) {
  return axios.put(`financeiro/contas-financeiras/${conta.id}`, conta).then((response) => response.data);
}

function excluir(id) {
  return axios.delete(`financeiro/contas-financeiras/${id}`).then((response) => response.data);
}

export default {
  listar,
  abrir,
  salvar,
  atualizar,
  excluir,
};
